import { CheckboxInput, IfFormData } from "ui-builder";
import { ProjectDetailsFieldType } from "nekst-api";
import { Separator } from "features/nekst-widgets";
import React from "react";
import { ManageCommissionAndClosingDateWrapper } from "feature-toggle";

export function IsClosingDateFieldInput() {

  return (
    <ManageCommissionAndClosingDateWrapper>
      <IfFormData<{ fieldType: ProjectDetailsFieldType }>
        conditionFunc={(data) => data.fieldType === ProjectDetailsFieldType.DATE}>
        <Separator />
        <CheckboxInput source="isClosingDateField" label="Use this box for closing date tracking" />
      </IfFormData>
    </ManageCommissionAndClosingDateWrapper>
  );
}
